module.exports = __webpack_public_path__ + "img/download-icon.aee780fc.png";